import { CloseCircleOutlined } from '@ant-design/icons'
import { Button, Result, ResultProps, Typography } from 'antd'
import { CSSProperties } from 'react'
import { Link } from 'react-router-dom'

const { Text } = Typography

const resultStyles: ResultProps['styles'] = {
  root: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}

const lineStyle: CSSProperties = { display: 'block', color: 'red' }

const ForbiddenPage = () => {
  return (
    <Result
      icon={<CloseCircleOutlined style={{ color: 'red' }} />}
      subTitle={
        <>
          <Text style={lineStyle}>
            You do not have sufficient permissions to access this page.
          </Text>
          <Text style={lineStyle}>
            Please contact your organization's administrator if you believe you
            should have access.
          </Text>
        </>
      }
      extra={
        <Link to="/">
          <Button type="primary">Back home</Button>
        </Link>
      }
      styles={resultStyles}
    />
  )
}

export default ForbiddenPage
